class AlpSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.buttonPrev = null;
    this.buttonNext = null;
    this.paginationEl = null;
    this.totalSlides = null;
  }

  gotoSlide(direction) {
    direction > 0 ? this.swiper.slideNext() : this.swiper.slidePrev();
  }

  setNavigationButtonsState() {
    if (!this.buttonPrev && !this.buttonNext) {
      return;
    }
    const prevCl = this.buttonPrev.classList;
    const nextCl = this.buttonNext.classList;

    this.swiper.isBeginning ? prevCl.add('disabled') : prevCl.remove('disabled');
    this.swiper.isEnd ? nextCl.add('disabled') : nextCl.remove('disabled');
  }

  updatePaginationLabel() {
    if (this.paginationEl) {
      this.paginationEl.setAttribute('current-item', this.swiper.realIndex);
      this.paginationEl.setAttribute('total-items', this.totalSlides);
    }
  }

  init() {
    this.buttonPrev = this.querySelector('.swiper-navigation-button.previous');
    this.buttonNext = this.querySelector('.swiper-navigation-button.next');
    this.paginationEl = this.querySelector('alp-slider-navigation');
    const type = this.getAttribute('type');
    const isFreeMode =  this.getAttribute('free-mode');

    const swiperEl = this.querySelector('.swiper');
    const swiperConfig = {
      on: {
        init: (swp) => {
          this.swiper = swp;
          this.totalSlides = swp.slides.length;
          if (this.buttonPrev && this.buttonNext) {
            this.buttonNext.addEventListener('click', this.gotoSlide.bind(this, 1));
            this.buttonPrev.addEventListener('click', this.gotoSlide.bind(this, -1));
          }

          this.setNavigationButtonsState();
          this.updatePaginationLabel();
        },
        slideChange: () => {
          this.setNavigationButtonsState();
          this.updatePaginationLabel();
        },
        breakpoint: (swp, breakpointParams) => {
          console.log('breakpointParams: ', breakpointParams);
        }
      },
      allowTouchMove: true,
      simulateTouch: true
    };
    const confFreeMode = {
      slidesPerView: 'auto',
      freeMode: true,
      allowTouchMove: true,
      simulateTouch: true
    }

    if (swiperEl) {
      new Swiper(
        swiperEl,
        isFreeMode ? confFreeMode : swiperConfig
      );
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 100);
  }
}

class AlpSliderPagination  extends HTMLElement {
  constructor() {
    super();
  }

  // 02 — 04
  updateNumbers(currentItem, totalItems) {
    const paginationEl = this.querySelector('.pagination-label');
    if (paginationEl) {
      const current = AlpHelpers.padNumber(currentItem + 1, 2);
      paginationEl.innerText = `${current} — ${AlpHelpers.padNumber(totalItems, 2)}`;
    }

  }

  updateDots(current, totalItems) {
    const dotsElContainer = this.querySelector('.swiper-navigation-dots-wrapper');

    if (totalItems > 0 && dotsElContainer) {
      let dotsEl = '';

      Array.from(Array(totalItems).keys()).forEach((value) => {
        const dot = document.createElement('span');
        dot.setAttribute('class', 'dot');
        value === current && dot.setAttribute('class', 'dot active');

        dotsEl += dot.outerHTML;
      });

      dotsElContainer.innerHTML = dotsEl;
    }
  }

  static get observedAttributes() {
    return ['type', 'total-items', 'current-item', 'free-mode'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.render();
  }
  render() {
    const type = this.getAttribute('type');
    const totalItems = parseInt(this.getAttribute('total-items'), 10);
    const currentItem = parseInt(this.getAttribute('current-item'), 10);

    if (type === 'number') {
      this.updateNumbers(currentItem, totalItems);
    }
    if (type === 'dots') {
      this.updateDots(currentItem, totalItems);
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.render();
    }, 250);
  }
}

class AlpContentAnchors  extends HTMLElement {
  constructor() {
    super();
    this.headerHeight = null;
  }

  gotoSection(evt) {
    evt && evt.preventDefault();
    const href = evt.target.getAttribute("href");
    try {
      const offsetTop = document.querySelector(href).offsetTop;

      window.scroll({
        top: offsetTop - this.headerHeight,
        behavior: "smooth"
      });
    } catch (e) {
      console.error('gotoSection > error: ', e);
    }

  }

  getAnchor(targetEl, label) {
    const el = document.createElement('a');

    el.href = `#${targetEl.getAttribute('id')}`;
    el.innerText = label;
    el.addEventListener('click', this.gotoSection.bind(this));

    return el;
  }

  init() {
    const descriptionEl = document.querySelector('div[id*="metafield-sections-"]');
    const deliveryEl = document.querySelector('div[id*="section-rich-text-shipping"]');
    const returnsEl = document.querySelector('div[id*="section-rich-text-return"]');
    const headerEl = document.querySelector('header')
    this.headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0

    descriptionEl && this.appendChild(this.getAnchor(descriptionEl, this.dataset.description));
    deliveryEl && this.appendChild(this.getAnchor(deliveryEl, this.dataset.delivery));
    returnsEl && this.appendChild(this.getAnchor(returnsEl, this.dataset.returns));
  }

  connectedCallback() {
    window.addEventListener('load', () => {
      this.init();
    });
  }
}

class AlpAccordion  extends HTMLElement {
  constructor() {
    super();
    this.entries = null;
    this.keepOpen = false;
  }

  closeAll() {
    this.entries.forEach((item) => {
      item.close();
    })
  }

  onItemClicked(evt) {
    try {
      evt.detail.isOpen && this.closeAll();
    } catch (e) {
      console.error('onItemClicked -> error: ', e);
    }
  }

  init() {
    this.entries = this.querySelectorAll('alp-accordion-item');
    this.keepOpen = this.getAttribute('keep-opened') === 'true';

    if (this.entries) {
      if (!this.keepOpen) {
        this.entries.forEach((item) => {
          item.addEventListener('onOpenStateChanged', this.onItemClicked.bind(this));
        })
      }
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 250);
  }
}

class AlpAccordionItem  extends HTMLElement {
  PADDING = 16;
  constructor() {
    super();
    this.openState = false;
    this.contentEl = null;
    this.contentHeight = 0;
    this.iconPlusEl = null;
    this.iconMinusEl = null;
    this.contentWrapperEl = null;
  }

  changeIcon() {
    if (this.openState) {
      this.iconPlusEl.classList.toggle('hidden', true);
      this.iconMinusEl.classList.remove('hidden');
    } else {
      this.iconMinusEl.classList.toggle('hidden', true);
      this.iconPlusEl.classList.remove('hidden');
    }
  }

  open() {
    this.dispatchEvent(new CustomEvent('onOpenStateChanged', {
      detail: {isOpen: true}
    }));
    this.contentWrapperEl.style.height = `${this.contentHeight}px`;
    this.openState = true;
    this.changeIcon();
  }

  close() {
    this.contentWrapperEl.style.height = `0px`;
    this.openState = false;
    this.changeIcon();
  }

  onResize() {
    setTimeout(() => {
      this.contentHeight = this.contentEl.getBoundingClientRect().height + this.PADDING;
      this.openState && (this.contentWrapperEl.style.height = `${this.contentHeight}px`);
    }, 100);
  }

  init() {
    this.contentEl = this.querySelector('.content-wrapper .inner');
    const buttonEl = this.querySelector('button');
    if (!this.contentEl) {
      return;
    }

    this.iconPlusEl = this.querySelector('.icon-plus-minus .plus');
    this.iconMinusEl = this.querySelector('.icon-plus-minus .minus');
    this.contentHeight = this.contentEl.getBoundingClientRect().height + this.PADDING;
    this.contentWrapperEl = this.querySelector('.content-wrapper');
    buttonEl.addEventListener('click', () => {
      this.openState ? this.close() :  this.open();
    });

    this.close();
    // Replace content
    this.contentEl.classList.remove('loading-state');

    // Responsive
    window.addEventListener('resize', this.onResize.bind(this));
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 250);
  }
}

class AlpImageText  extends HTMLElement {
  PADDING = 16;
  constructor() {
    super();
    this.mainContainer = null;
    this.blockImageEl = null;
    this.blockTextEl = null;
  }

  render() {
    const blockImageWidth = this.blockImageEl.getBoundingClientRect().width;
    const imageBound = this.blockImageEl.querySelector('.image-wrapper').getBoundingClientRect();
    const paddingY = Math.floor((blockImageWidth - imageBound.width) / 2);
    const textHeight = this.blockTextEl.querySelector('.text-wrapper').getBoundingClientRect().height;

    const textTopSpacerEl = this.blockTextEl.querySelector('.text-top-spacer');
    let spacerHeight = paddingY;

    // Padding image block
    if (paddingY) {
      this.blockImageEl.style.paddingTop = `${paddingY}px`;
      this.blockImageEl.style.paddingBottom = `${paddingY}px`;
    }

    // If Text is shorter than image
    // we align vertical center
    this.blockTextEl.classList.remove('items-center');
    if (textHeight < imageBound.height) {
      spacerHeight = 0;
      this.blockTextEl.classList.add('items-center');
      this.blockTextEl.classList.add('h-full');
    }

    textTopSpacerEl.style.height = `${spacerHeight}px`;
    this.blockImageEl.classList.remove('invisible');
    this.blockTextEl.classList.remove('invisible');
  }

  onResize() {
    setTimeout(() => {
      this.render();
    }, 250);
  }

  init() {
    this.mainContainer = this.querySelector('section.image-with-text-wrapper');
    this.blockImageEl = this.querySelector('.image-block');
    this.blockTextEl = this.querySelector('.text-block');

    if (this.blockImageEl && this.blockTextEl) {
      window.addEventListener('resize', this.onResize.bind(this));
      this.onResize();
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 250);
  }
}

class AlpHeadline  extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    if (this.dataset.bgImage) {
      const img = document.createElement('img');
      img.onload = () => {
        this.classList.add('bg-red');
      }
      img.src = this.dataset.bgImage;
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 250);
  }
}

class AlpParallax  extends HTMLElement {
  constructor() {
    super();
    // this.mainRallax = new Rallax();
  }

  onScroll(items) {
    const rect = this.getBoundingClientRect();
    const middle  = rect.y + (rect.height / 2);
    const distance = middle - (window.innerHeight / 2);
    const inWindow = rect.y >= 0 && (rect.y + (rect.height / 2)) <= window.innerHeight;

    if(this.items) {
      if (inWindow) {
          if (window.innerWidth >= 640) {
              requestAnimationFrame(() => {
                this.items.forEach(el => {
                  const posY = parseFloat(el.dataset.speed) * distance;
                  el.style.transform = `translate3d(0, ${Math.floor(posY)}px, 0)`;
                })
              });
          }
          this.resetTransform();
      }
    }
  }

  resetTransform() {
    if (window.innerWidth < 640) {
      if(this.items) {
        this.items.forEach(el => {
          el.style.transform = 'unset';
        });
      }
    }
  }

  init() {
    this.items = this.querySelectorAll('.image-wrapper[data-speed]');
    window.addEventListener('scroll', this.onScroll.bind(this));
    window.addEventListener('resize', this.resetTransform.bind(this));
    this.onScroll();
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }
}


customElements.define('alp-slider', AlpSlider);
customElements.define('alp-content-anchors', AlpContentAnchors);
customElements.define('alp-slider-navigation', AlpSliderPagination);
customElements.define('alp-accordion', AlpAccordion);
customElements.define('alp-accordion-item', AlpAccordionItem);
customElements.define('alp-image-text', AlpImageText);
customElements.define('alp-headline', AlpHeadline);
customElements.define('alp-parallax', AlpParallax);
